"use strict";
// THIS FILE IS GENERATED AUTOMATICALLY. DO NOT MODIFY.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryClient = exports.txClient = exports.registry = exports.MissingWalletError = void 0;
const stargate_1 = require("@cosmjs/stargate");
const proto_signing_1 = require("@cosmjs/proto-signing");
const rest_1 = require("./rest");
const tx_1 = require("./types/nftoracle/tx");
const tx_2 = require("./types/nftoracle/tx");
const tx_3 = require("./types/nftoracle/tx");
const tx_4 = require("./types/nftoracle/tx");
const tx_5 = require("./types/nftoracle/tx");
const tx_6 = require("./types/nftoracle/tx");
const tx_7 = require("./types/nftoracle/tx");
const tx_8 = require("./types/nftoracle/tx");
const tx_9 = require("./types/nftoracle/tx");
const tx_10 = require("./types/nftoracle/tx");
const tx_11 = require("./types/nftoracle/tx");
const tx_12 = require("./types/nftoracle/tx");
const tx_13 = require("./types/nftoracle/tx");
const tx_14 = require("./types/nftoracle/tx");
const tx_15 = require("./types/nftoracle/tx");
const types = [
    ["/thesixnetwork.sixnft.nftoracle.MsgCreateMintRequest", tx_1.MsgCreateMintRequest],
    ["/thesixnetwork.sixnft.nftoracle.MsgCreateActionSigner", tx_2.MsgCreateActionSigner],
    ["/thesixnetwork.sixnft.nftoracle.MsgDeleteActionSigner", tx_3.MsgDeleteActionSigner],
    ["/thesixnetwork.sixnft.nftoracle.MsgCreateVerifyCollectionOwnerRequest", tx_4.MsgCreateVerifyCollectionOwnerRequest],
    ["/thesixnetwork.sixnft.nftoracle.MsgUpdateActionSignerConfig", tx_5.MsgUpdateActionSignerConfig],
    ["/thesixnetwork.sixnft.nftoracle.MsgSetMinimumConfirmation", tx_6.MsgSetMinimumConfirmation],
    ["/thesixnetwork.sixnft.nftoracle.MsgCreateActionRequest", tx_7.MsgCreateActionRequest],
    ["/thesixnetwork.sixnft.nftoracle.MsgCreateActionSignerConfig", tx_8.MsgCreateActionSignerConfig],
    ["/thesixnetwork.sixnft.nftoracle.MsgCreateSyncActionSigner", tx_9.MsgCreateSyncActionSigner],
    ["/thesixnetwork.sixnft.nftoracle.MsgSubmitMintResponse", tx_10.MsgSubmitMintResponse],
    ["/thesixnetwork.sixnft.nftoracle.MsgSubmitVerifyCollectionOwner", tx_11.MsgSubmitVerifyCollectionOwner],
    ["/thesixnetwork.sixnft.nftoracle.MsgSubmitSyncActionSigner", tx_12.MsgSubmitSyncActionSigner],
    ["/thesixnetwork.sixnft.nftoracle.MsgUpdateActionSigner", tx_13.MsgUpdateActionSigner],
    ["/thesixnetwork.sixnft.nftoracle.MsgDeleteActionSignerConfig", tx_14.MsgDeleteActionSignerConfig],
    ["/thesixnetwork.sixnft.nftoracle.MsgSubmitActionResponse", tx_15.MsgSubmitActionResponse],
];
exports.MissingWalletError = new Error("wallet is required");
exports.registry = new proto_signing_1.Registry(types);
const defaultFee = {
    amount: [],
    gas: "200000",
};
const txClient = (wallet, { addr: addr } = { addr: "http://localhost:26657" }, options) => __awaiter(void 0, void 0, void 0, function* () {
    if (!wallet)
        throw exports.MissingWalletError;
    let client;
    if (addr) {
        client = yield stargate_1.SigningStargateClient.connectWithSigner(addr, wallet, Object.assign({ registry: exports.registry }, options));
    }
    else {
        client = yield stargate_1.SigningStargateClient.offline(wallet, { registry: exports.registry });
    }
    const { address } = (yield wallet.getAccounts())[0];
    return {
        signAndBroadcast: (msgs, { fee, memo } = { fee: defaultFee, memo: "" }) => client.signAndBroadcast(address, msgs, fee, memo),
        msgCreateMintRequest: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgCreateMintRequest", value: tx_1.MsgCreateMintRequest.fromPartial(data) }),
        msgCreateActionSigner: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgCreateActionSigner", value: tx_2.MsgCreateActionSigner.fromPartial(data) }),
        msgDeleteActionSigner: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgDeleteActionSigner", value: tx_3.MsgDeleteActionSigner.fromPartial(data) }),
        msgCreateVerifyCollectionOwnerRequest: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgCreateVerifyCollectionOwnerRequest", value: tx_4.MsgCreateVerifyCollectionOwnerRequest.fromPartial(data) }),
        msgUpdateActionSignerConfig: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgUpdateActionSignerConfig", value: tx_5.MsgUpdateActionSignerConfig.fromPartial(data) }),
        msgSetMinimumConfirmation: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgSetMinimumConfirmation", value: tx_6.MsgSetMinimumConfirmation.fromPartial(data) }),
        msgCreateActionRequest: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgCreateActionRequest", value: tx_7.MsgCreateActionRequest.fromPartial(data) }),
        msgCreateActionSignerConfig: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgCreateActionSignerConfig", value: tx_8.MsgCreateActionSignerConfig.fromPartial(data) }),
        msgCreateSyncActionSigner: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgCreateSyncActionSigner", value: tx_9.MsgCreateSyncActionSigner.fromPartial(data) }),
        msgSubmitMintResponse: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgSubmitMintResponse", value: tx_10.MsgSubmitMintResponse.fromPartial(data) }),
        msgSubmitVerifyCollectionOwner: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgSubmitVerifyCollectionOwner", value: tx_11.MsgSubmitVerifyCollectionOwner.fromPartial(data) }),
        msgSubmitSyncActionSigner: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgSubmitSyncActionSigner", value: tx_12.MsgSubmitSyncActionSigner.fromPartial(data) }),
        msgUpdateActionSigner: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgUpdateActionSigner", value: tx_13.MsgUpdateActionSigner.fromPartial(data) }),
        msgDeleteActionSignerConfig: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgDeleteActionSignerConfig", value: tx_14.MsgDeleteActionSignerConfig.fromPartial(data) }),
        msgSubmitActionResponse: (data) => ({ typeUrl: "/thesixnetwork.sixnft.nftoracle.MsgSubmitActionResponse", value: tx_15.MsgSubmitActionResponse.fromPartial(data) }),
    };
});
exports.txClient = txClient;
const queryClient = ({ addr: addr } = { addr: "http://localhost:1317" }) => __awaiter(void 0, void 0, void 0, function* () {
    return new rest_1.Api({ baseUrl: addr });
});
exports.queryClient = queryClient;
//# sourceMappingURL=index.js.map